import { Log, UserManager } from 'oidc-client-ts';

import { config } from '../../config.ts';
import { routeStorage } from './storage.ts';

export const isLoginRedirect = () => {
    if (!config.login.redirectUri) {
        return false;
    }
    const redirect = new URL(config.login.redirectUri);
    return window.location.origin === redirect.origin && window.location.pathname === redirect.pathname;
};

export const handleSilentLoginRedirect = () => {
    Log.setLogger(console);
    Log.setLevel(Log.INFO);

    // Pass the iframe response to the parent window's UserManager.
    void new UserManager({
        authority: `${config.login.authority}`,
        client_id: `${config.login.clientId}`,
        redirect_uri: `${config.login.redirectUri}`,
    }).signinSilentCallback();
};

export const completeLoginRedirect = async (userManager: UserManager) => {
    await userManager.signinRedirectCallback();
    const initialRoute = routeStorage.getRoute();
    routeStorage.discardRoute();
    window.history.replaceState(null, '', `${window.location.origin}/#/${initialRoute ?? ''}`);
};

export const showLoginRedirectError = () => {
    routeStorage.discardRoute();
    window.history.replaceState(null, '', `${window.location.origin}/`);
    const root = document.getElementById('root');
    if (root) {
        root.textContent = 'Sign-in failed. Reload to try again.';
    }
};
